/**
 * 车辆基本信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆配置信息
Mock.mock(/\/car_model\/\d+\/configurations/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    configurations: [
      {
        'name': '基本参数',
        'group_name': 'basic',
        'params': [
          {
            'name': '车门数(个)',
            'external_name': 'body_doors',
            'value': null
          }, {
            'name': '座位数(个)',
            'external_name': 'perf_seatnum',
            'value': null
          },
          {
            'name': '排量(L)',
            'external_name': 'Engine_ExhaustForFloat',
            'value': null
          },
          {
            'name': '燃料类型',
            'external_name': 'Oil_FuelType',
            'value': null
          },
          {
            'name': '挡位个数(个)',
            'external_name': 'UnderPan_ForwardGearNum',
            'value': null
          },
          {
            'name': '变速箱类型',
            'external_name': 'UnderPan_TransmissionType',
            'value': null
          },
          {
            'name': '驱动方式',
            'external_name': 'Perf_DriveType',
            'value': null
          }
        ]
      }, {
        'name': '主/被动安全设备',
        'group_name': 'security',
        'params': [
          {
            'name': '被动安全装备',
            'external_name': '驾驶位安全气囊,Safe_DriverGasBag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '副驾驶位安全气囊,Safe_SubDriverGasBag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '前排侧安全气囊,Safe_FsadGasbag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '后排侧安全气囊,Safe_BsadGasbag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '前排头部气囊(气帘),Safe_FheadGasbag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '膝部气囊,Safe_KneeGasBag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '安全带气囊,InStat_BeltBag',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '胎压监测装置,UnderPan_TyrePressureWatcher',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '刹车防抱死(ABS),Safe_ABS',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '盲点检测/并线辅助,InStat_blindspotdetection',
            'value': null
          },
          {
            'name': '被动安全装备',
            'external_name': '夜视系统,InStat_NightVisionSystem',
            'value': null
          }
        ]
      }, {
        'name': '辅助/操控配置',
        'group_name': 'accessory',
        'params': [
          {
            'name': '操控配置',
            'external_name': '泊车雷达(车前),UnderPan_PRadar',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '倒车雷达(车后),UnderPan_RRadar',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '倒车影像,UnderPan_RImage',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '全景摄像头,InStat_PanoramicCamera',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '定速巡航,InStat_SpeedCruise',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '自适应巡航,InStat_Automaticcruise',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '自动泊车入位,InStat_AutoParking',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '上坡辅助,InStat_UphillAuxiliary',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '自动驻车,InStat_AutoPark',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '陡坡缓降,InStat_HDC',
            'value': null
          },
          {
            'name': '操控配置',
            'external_name': '遥控驾驶,Safe_Remotedriving',
            'value': null
          }
        ]
      },
      {
        'name': '外部/防盗配置',
        'group_name': 'external',
        'params': [
          {
            'name': '防盗配置',
            'external_name': '天窗型式,Body_Louver',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '运动外观套件,OutStat_SportsAppearanceKit',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '铝合金轮圈,Aluminum_alloy_wheels # 没有标明',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '感应行李厢,Induction_trunk',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '车顶行李箱架,OutStat_TopSnelf',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '无钥匙启动系统,InStat_AIgnitionSys',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '无钥匙进入系统,nokey_into',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '遥控启动,InStat_RemoteStart',
            'value': null
          },
          {
            'name': '防盗配置',
            'external_name': '后导流尾翼,OutStat_InductEmpennage',
            'value': null
          }
        ]
      },
      {
        'name': '内部配置',
        'group_name': 'internal',
        'params': [
          {
            'name': '多功能方向盘',
            'external_name': 'InStat_MultiFuncSteer',
            'value': null
          },
          {
            'name': '换挡拨片',
            'external_name': 'InStat_SteerEtc',
            'value': null
          },
          {
            'name': '方向盘加热',
            'external_name': 'Steering_Wheel_hot',
            'value': null
          },
          {
            'name': '方向盘记忆设置',
            'external_name': 'InStat_SteerMomery',
            'value': null
          },
          {
            'name': '方向盘表面材料',
            'external_name': 'InStat_SteerMaterial',
            'value': null
          },
          {
            'name': 'HUD抬头数字显示',
            'external_name': 'InStat_Hud',
            'value': null
          }
        ]
      },
      {
        'name': '座椅配置',
        'group_name': 'seat',
        'params': [
          {
            'name': '座椅材料',
            'external_name': 'InStat_SeatMaterial',
            'value': null
          },
          {
            'name': '运动座椅',
            'external_name': 'InStat_SportSeat',
            'value': null
          },
          {
            'name': '驾驶座腰部支撑调节',
            'external_name': 'InStat_DSeatProp',
            'value': null
          },
          {
            'name': '驾驶座肩部支撑调节',
            'external_name': 'InStat_AdjustableShoulderSupport',
            'value': null
          },
          {
            'name': '驾驶座座椅调节方式',
            'external_name': 'InStat_DSeatTuneType',
            'value': null
          },
          {
            'name': '副驾驶座椅调节方式',
            'external_name': 'InStat_DASeatTuneType',
            'value': null
          },
          {
            'name': '电动座椅记忆',
            'external_name': 'InStat_ElectricSeatMemory',
            'value': null
          },
          {
            'name': '前排座椅加热',
            'external_name': 'Heated_front_seats',
            'value': null
          },
          {
            'name': '后排座椅加热',
            'external_name': 'Heated_rear_seats',
            'value': null
          },
          {
            'name': '前排座椅通风',
            'external_name': 'The_front_seat_ventilation',
            'value': null
          },
          {
            'name': '后排座椅通风',
            'external_name': 'Rear_seat_ventilation',
            'value': null
          },
          {
            'name': '座椅按摩功能',
            'external_name': 'InStat_SeatKnead',
            'value': null
          },
          {
            'name': '第三排座椅',
            'external_name': 'InStat_3rdRowSeats',
            'value': null
          }
        ]
      },
      {
        'name': '多媒体配置',
        'group_name': 'multimedia',
        'params': [
          {
            'name': 'GPS导航系统',
            'external_name': 'InStat_GPS',
            'value': null
          },
          {
            'name': '中控台液晶屏',
            'external_name': 'InStat_CCEscreen',
            'value': null
          },
          {
            'name': '后排液晶屏',
            'external_name': 'InStat_BEscreen',
            'value': null
          },
          {
            'name': '蓝牙系统',
            'external_name': 'InStat_Bluetooth',
            'value': null
          },
          {
            'name': '无线上网功能',
            'external_name': 'InStat_WireLink',
            'value': null
          },
          {
            'name': '车载电视',
            'external_name': 'InStat_Video',
            'value': null
          },
          {
            'name': 'CD',
            'external_name': 'InStat_CDPlayer',
            'value': null
          },
          {
            'name': 'DVD',
            'external_name': 'InStat_DVDPlayer',
            'value': null
          }
        ]
      },
      {
        'name': '灯光配置',
        'group_name': 'light',
        'params': [
          {
            'name': '日间行车灯',
            'external_name': 'OutStat_DaytimeRunningLights',
            'value': null
          },
          {
            'name': '前大灯自动开闭',
            'external_name': 'OutStat_FLightClose',
            'value': null
          },
          {
            'name': '前雾灯',
            'external_name': 'OutStat_FfogLamp',
            'value': null
          },
          {
            'name': '前大灯自动清洗功能',
            'external_name': 'OutStat_FLightAutoClean',
            'value': null
          },
          {
            'name': '前大灯随动转向',
            'external_name': 'OutStat_FLightSteer',
            'value': null
          },
          {
            'name': '前大灯类型',
            'external_name': 'OutStat_FrontLightType',
            'value': null
          }
        ]
      },
      {
        'name': '玻璃/后视镜',
        'group_name': 'glass',
        'params': [
          {
            'name': '后视镜',
            'external_name': 'The_front_power_window',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'After_the_electric_window',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_ReMirrorElecTune',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_ReMirrorHot',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_ReMirrorDazzle',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_ReMirrorFold',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_ReMirrormemory',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_BackCurtain',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_SecondRowCurtain',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'InStat_FaceMirror',
            'value': null
          },
          {
            'name': '后视镜',
            'external_name': 'OutStat_BBrushSensor',
            'value': null
          }
        ]
      }, {
        'name': '空调/冰箱',
        'group_name': 'refrigeration',
        'params': [
          {
            'name': '冰箱',
            'external_name': 'InStat_AirCType',
            'value': null
          },
          {
            'name': '冰箱',
            'external_name': 'InStat_BAirCSystem',
            'value': null
          },
          {
            'name': '冰箱',
            'external_name': 'InStat_TemperSubCount',
            'value': null
          },
          {
            'name': '冰箱',
            'external_name': 'InStat_carFridge',
            'value': null
          }
        ]
      }
    ]
  }
})
// 保存配置信息和手续信息提交
Mock.mock(/\/used_car\/ticket\/car_info\/\d+\/info/, 'post' + mockSwitch, {
  code: 0,
  message: 'ok',
  data: {
    is_details_ready: false // 是否完备
  }
})

Mock.mock(/\/used_car\/ticket\/car_info\/\d+\/remark/, 'post' + mockSwitch, {
  code: 0,
  message: 'ok',
  data: {
    is_details_ready: false // 是否完备
  }
})
